<template>
  <v-dialog
    :value="value"
    :persistent="loading"
    width="400"
    @input="$emit('input', $event)"
  >
    <v-card :disabled="loading" :loading="loading">
      <v-form :disabled="loading" @submit.prevent="submitChanges">
        <v-card-title>Edit child birthday</v-card-title>
        <v-card-text>
          <v-date-picker
            v-model="birthday"
            :max="maxPickerDate"
            width="100%"
            color="blue"
            style="width: 100%;"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            text
            @click="close"
          >
            Close
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="isInitialBirthday"
            type="submit"
            color="blue"
            class="white--text"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const PICKER_DATE_FORMAT = 'YYYY-MM-DD';

export default {
  name: 'EditChildBirthdayDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      birthday: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters('children', [
      'activeChildProfile',
    ]),
    maxPickerDate() {
      return this.$moment().format(PICKER_DATE_FORMAT);
    },
    isInitialBirthday() {
      const initial = this.$moment(this.activeChildProfile.birthday).format(PICKER_DATE_FORMAT);
      return this.$moment(this.birthday).isSame(initial);
    },
  },
  created() {
    this.initFormData();
  },
  methods: {
    ...mapActions('children', [
      'updateActiveChild',
    ]),
    submitChanges() {
      if (this.loading) return;

      this.loading = true;
      this.updateActiveChild({ birthday: this.birthday })
        .then(() => {
          this.$toast.success('Birthday successfully updated');
          this.initFormData();
        })
        .catch(() => this.$toast.error('Failed to update birthday'))
        .finally(() => (this.loading = false));
    },
    close() {
      this.$emit('input', false);
    },
    initFormData() {
      this.birthday = this.$moment(this.activeChildProfile.birthday).format(PICKER_DATE_FORMAT);
    },
  },
};
</script>
